import {
  getUserServiceFlag,
  OKTAUserServiceFlagEnum,
} from "@src/app/hooks/useUserInfo.ts";

export default function hasServiceFlag(
  serviceFlagToCheck: OKTAUserServiceFlagEnum,
) {
  const serviceFlags = getUserServiceFlag() || "";
  if (!serviceFlags) return false;
  const services = serviceFlags.split("|");
  return services.includes(serviceFlagToCheck);
}
